import React, { useEffect, useState, useRef } from 'react'
import { FaTimes } from 'react-icons/fa'
import SbEditable from 'storyblok-react'
import RichText from 'src/utils/RichText'
import Heading from 'src/components/Heading'
import { navigate } from 'gatsby'
import resolveLink from 'src/utils/resolveLink'
import { useLocation } from "@reach/router";

const Popup = ({ blok }) => {
  const [showPopup, setShowPopup] = useState(false)
  const popupRef = useRef(null)
  const location = useLocation();

  const handleSubmit = event => {
    event.preventDefault()
    const params = new URLSearchParams(location.search);
    const gclid = params.get("gclid");
    var form = new FormData(event.target)
    form.append('gclid', gclid);
    form.append('page_referrer', location.origin + location.pathname);
    
    fetch('/', {
      method: 'POST',
      headers: { "Content-Type": "application/x-www-form-urlencoded" },
      body: new URLSearchParams(form).toString()
    })
      .then(() => {
        localStorage.setItem('popup', 'true')
        navigate(resolveLink(blok?.action.cached_url))
        handleClose()
      })
      .catch(error => {
        console.log(error)
        handleClose()
      })
  }


  
  const handleClose = () => {
    setShowPopup(false)
  }

  useEffect(() => {
    const delay = Math.max(2, blok?.popupDelaySeconds) * 1000
    const timer = setTimeout(() => {
      if(localStorage.getItem('popup') === 'true') return
      setShowPopup(true)
    }, delay)

    return () => clearTimeout(timer)
  }, [blok?.popupDelaySeconds])

  useEffect(() => {
    const handleClickOutside = event => {
      if (popupRef.current && !popupRef.current.contains(event.target)) {
        handleClose()
      }
    }
    if (showPopup) {
      document.addEventListener('mousedown', handleClickOutside)
    } else {
      document.removeEventListener('mousedown', handleClickOutside)
    }

    return () => {
      document.removeEventListener('mousedown', handleClickOutside)
    }
  }, [showPopup])

  if (!showPopup || blok?.popup_toggle === false) return null

  return (
    <SbEditable content={{ blok }}>
      <div className='fixed top-0 left-0  sm:h-[100vh] sm:overflow-hidden overflow-auto w-full h-full flex justify-center items-center z-[10000] bg-black bg-opacity-50 '>
        <div
          ref={popupRef}
          className='bg-white rounded-3xl flex flex-col sm:flex-row relative w-full md:w-full sm:max-w-5xl  xl:max-w-5xl md:mt-0 m-3  '
        >
          <button
            onClick={handleClose}
            className='absolute top-0 right-0 mt-2 mr-2 text-gray-500 hover:text-gray-700'
          >
            <FaTimes style={{ fontSize: '24px' }} />
          </button>

         {blok?.mobileimage[0]?.filename? <div className='sm:hidden flex justify-center items-center'>
            <img
              className='rounded-t-3xl  w-full  object-cover min-h-40'
              src={blok?.mobileimage[0]?.filename}
              alt={blok?.mobileimage[0]?.alt || ''}
            />
          </div>:''}

          <div className='flex-1 p-4 max-h-full max-w-full overflow-hidden break-words sm:px-2 px-4 md:px-10 py-4 content-center w-full md:w-[30%]'>
            <h2
              className='text-center text-xl font-bold mb-2'
              style={{ color: 'rgb(2, 210, 160)' }}
            >
              <Heading
                className='mb-12 block'
                size='h5'
                style={{ fontSize: '24px' }} // Set the font size here
              >
                {blok.title}
              </Heading>
            </h2>

            <h5 className='text-center text-xl font-bold mb-3'>
              <p style={{ fontSize: '17px' }}>{blok?.subtitle}</p>
            </h5>

            <p className='text-center mb-4 text-xs'>{blok?.description}</p>

            <form
              name='Popup Form'
              method='POST'
              data-netlify='true'
              netlify-honeypot="bot-field"
              onSubmit={handleSubmit}
            >
              <input type="hidden" name="bot-field" />
              <input type="hidden" name='form-name' value='Popup Form' />
              <div className='md:mb-5 mb-2 flex flex-col gap-3'>
                <input
                  type='text'
                  placeholder={blok?.name}
                  required
                  className='border border-gray-300 rounded-md mb-2 block w-full'
                  name='Name'
                />
                <input
                  type='email'
                  placeholder={blok?.email}
                  required
                  className='border border-gray-300 rounded-md mb-2 block w-full'
                  name='Email'
                />
                {blok.phoneNumberFiledToggle && (
                  <input
                    type='number'
                    placeholder={blok?.number}
                    className='border border-gray-300 rounded-md mb-2 block w-full'
                    name='Phone number'
                  />
                )}
              </div>
              <div className='flex justify-center items-center mb-4'>
                <button
                  type='submit'
                  className='text-black py-2 px-4 rounded-md mr-2 font-bold'
                  style={{ backgroundColor: '#02d2a0', width: '100%' }}
                >
                  {blok?.button_text}
                </button>
              </div>
            </form>

            <p className='text-center text-gray-500 mt-2 mb-4 text-xs'>
              <RichText>{blok?.small_print_text}</RichText>
            </p>
          </div>

          <img
            className='hidden object-cover sm:flex flex-1 justify-center items-center md:w-[40%] sm:w-[40%] rounded-r-3xl max-w-[450px]'
            src={blok?.image[0]?.filename}
            alt={blok?.image[0]?.alt || ''}
          />
        </div>
      </div>
    </SbEditable>
  )
}

export default Popup
